/**
 * Unified Bearer-header source for every embedded copilot surface.
 *
 * Merges the two session stores — the Office add-in's bespoke MSAL/WebView2
 * store (`office-addin-session.ts`) and the generic surface-keyed store
 * (`host-session-store.ts`). Each returns `{}` when not applicable, and a
 * client is only ever in one embedded host, so the merge is safe and yields
 * at most one `Authorization` header.
 *
 * Used by `lib/magnus-client.ts` so all outgoing fetches (tRPC, SDK) carry the
 * right session token regardless of which copilot the client is running in.
 */

import { getHostSessionHeaders } from "./host-session-store";
import { getOfficeAddinSessionHeaders } from "./office-addin-session";

export function getEmbeddedSessionHeaders(): Record<string, string> {
  return {
    ...getOfficeAddinSessionHeaders(),
    ...getHostSessionHeaders(),
  };
}
